export default "__VITE_ASSET__DstjDH81__"